import IngredientProcessContainer from './'

export const ingredientsProcessRoutes = {
  path: 'ingredients-process',
  restricted: false,
  component: IngredientProcessContainer,
}
